import { render, staticRenderFns } from "./formGovernancePolicy.vue?vue&type=template&id=3fc75480&scoped=true"
import script from "./formGovernancePolicy.vue?vue&type=script&lang=js"
export * from "./formGovernancePolicy.vue?vue&type=script&lang=js"
import style0 from "./formGovernancePolicy.vue?vue&type=style&index=0&id=3fc75480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc75480",
  null
  
)

export default component.exports